import styles from "./SimpleRadioGroup.module.css";
import classNames from "classnames";
import type { JSX } from "react";
import checkIcon from "../../assets/icons/check.svg";

type SimpleOption = {
  name: string;
  value: string | number | boolean;
};

type SimpleRadioGroup = {
  name: string;
  options: SimpleOption[];
  value?: string | boolean;
  variant?: "default" | "toggleButton";
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onValueChangedParse?: (value: string) => void;
  ariaLabelledBy?: string;
};

const SimpleRadioGroup = (props: SimpleRadioGroup): JSX.Element => {
  const { name, options, value, variant = "default", onValueChangedParse, onChange, ariaLabelledBy } = props;

  const onChangeParse = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (onValueChangedParse) {
      onValueChangedParse(evt.target.value);
    } else if (onChange) {
      onChange(evt);
    }
  };

  const groupClassNames = classNames(styles.radioGroup, { [styles.toggleButtonGroup]: variant === "toggleButton" });
  const labelClassNames = classNames({
    [styles.radioLabel]: variant === "default",
    [styles.toggleButtonLabel]: variant === "toggleButton",
  });

  return (
    <div role="radiogroup" className={groupClassNames} aria-labelledby={ariaLabelledBy}>
      {options.map((option) => (
        <label key={option.name} className={labelClassNames}>
          <input
            name={name}
            id={`${name}-${option.value.toString()}`}
            type="radio"
            className={styles.control}
            key={option.name}
            value={option.value.toString()}
            onChange={onChangeParse}
            checked={value == option.value}
          />
          <span className={styles.textWrapper}>
            {option.name}
            {value == option.value && variant === "toggleButton" && (
              <img src={checkIcon} alt="" className={styles.checkIcon} />
            )}
          </span>
        </label>
      ))}
    </div>
  );
};

export { SimpleRadioGroup };
